/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StarIcon from '../Icons/Star';

const StarsAwardContainer = styled.div`
  display: flex;

  svg {
    margin-right: 2px;
  }
`;

const Star = styled.span`
  color: ${props =>
    props.active ? 'var(--web-orange)' : 'var(--silver-polish)'};
  display: flex;
  align-items: center;

  &.star-award > svg {
    border-radius: 0;
    &:hover {
      box-shadow: none;
    }
  }
`;

const StarsAward = ({ max, earned, className }) => (
  <StarsAwardContainer className={className} data-testid="stars-award">
    {[...Array(max)].map((_, i) => {
      const active = i < (earned || 0);
      return (
        <Star
          className="star-award"
          key={i}
          active={active}
          data-testid="stars-award-star"
          data-active={active}
        >
          <StarIcon />
        </Star>
      );
    })}
  </StarsAwardContainer>
);

StarsAward.defaultProps = {
  className: '',
};

StarsAward.propTypes = {
  className: PropTypes.string,
  max: PropTypes.number.isRequired,
  earned: PropTypes.number.isRequired,
};

export default StarsAward;
